import styles from "./index.css";
import classNames from "classnames";
import logo from "../../images/asosWorldLogoWhiteText.png";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";

const LoyaltyBanner = ({
  header,
  copy,
  Button,
  imagePath,
  className,
  formatTranslation
}) => (
  <section className={classNames(styles.loyaltyBanner, className)}>
    <div className={styles.topNoise}></div>
    <div className={styles.leftShoulder}></div>
    <div className={styles.centeredContent}>
      <div className={styles.copyContainer}>
        <img
          alt={formatTranslation("quick_join_overlay_a11y_logo")}
          src={logo}
          className={styles.logo}
        />
        {header.split("/").map((text, index) => (
          <h1 className={styles.header} key={index}>
            {text}
          </h1>
        ))}
        <div className={styles.copy}>
          {copy.split("/").map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
        <Button />
      </div>
      <div className={styles.separator}></div>
      <div className={styles.imageContainer}>
        <img
          src={imagePath}
          alt={formatTranslation("quick_join_overlay_a11y_logo")}
        />
      </div>
    </div>
    <div className={styles.rightShoulder}></div>
    <div className={styles.bottomNoise}></div>
  </section>
);

LoyaltyBanner.propTypes = {
  header: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  Button: PropTypes.elementType,
  className: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(LoyaltyBanner);
